import { defineStore } from 'pinia';
import AuthService from '../services/auth.service';

let initAuthPromise = null;

export const useAuthStore = defineStore('auth', {
    state: () => ({
        loggedIn: false,
        user: null,
        initialized: false,
    }),
    actions: {
        async initAuth() {
            if (this.initialized) {
                return;
            }

            if (!initAuthPromise) {
                initAuthPromise = (async () => {
                    try {
                        const user = await AuthService.me();
                        this.loggedIn = true;
                        this.user = user;
                    } catch (error) {
                        this.loggedIn = false;
                        this.user = null;
                    } finally {
                        this.initialized = true;
                    }
                })();
            }

            await initAuthPromise;
        },
        login(user) {
            return AuthService.login(user).then(
                (userData) => {
                    this.loggedIn = true;
                    this.user = userData;
                    return Promise.resolve(userData);
                },
                (error) => {
                    this.loggedIn = false;
                    this.user = null;
                    return Promise.reject(error);
                }
            );
        },
        async logout() {
            await AuthService.logout();
            this.loggedIn = false;
            this.user = null;
            this.initialized = true;
        },
        register(user) {
            return AuthService.register(user).then(
                (responseData) => {
                    this.loggedIn = false;
                    return Promise.resolve(responseData);
                },
                (error) => {
                    this.loggedIn = false;
                    return Promise.reject(error);
                }
            );
        },
    },
});